import { createRoot } from "react-dom/client";
import "./index.scss";
import "@evidenceb/athena-common/athena-common.css";

import { recordLoadPhase } from "@evidenceb/debug-utils";
import type MatomoTracker from "@jonkoops/matomo-tracker";
import { createInstance, MatomoProvider } from "@jonkoops/matomo-tracker-react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { getLocalStorageFlags } from "./utils/flags";

// Time from navigation start until the main bundle is downloaded, parsed and
// evaluated (this module runs at the end of the entry chunk's evaluation)
recordLoadPhase("bundle.load-and-eval", 0, performance.now());

let matomoInstance: MatomoTracker | undefined;

if (import.meta.env.PROD) {
  if (window.location.hostname.endsWith("miaseconde.fr")) {
    // miaseconde is used in a more restricted environment that has its own matomo
    matomoInstance = createInstance({
      urlBase: "https://rufwgpchskepjzgwuclh-matomo.services.clever-cloud.com/",
      siteId: 5,
      linkTracking: false,
    });
  } else {
    matomoInstance = createInstance({
      urlBase: "https://charlemagne.evidenceb-services.com",
      siteId: 1,
      linkTracking: false,
    });
  }
}

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement, {
    onUncaughtError: (error, errorInfo) => {
      console.log("Uncaught error ", error, errorInfo);
    },
    onCaughtError: (error, errorInfo) => {
      console.log("Caught error ", error, errorInfo);
    },
  });
  root.render(
    typeof matomoInstance === "undefined" ? (
      <App />
    ) : (
      <MatomoProvider value={matomoInstance}>
        <App />
      </MatomoProvider>
    ),
  );
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (getLocalStorageFlags()["offlineFeatures"]) {
  console.log("REGISTER service worker");
  serviceWorkerRegistration.register();
} else {
  console.log("UNREGISTER service worker");
  serviceWorkerRegistration.unregister();
}

// TEMP: See https://github.com/EvidenceB/evb_application/pull/1695 This
// localStorage key used to be used for storing statements but the
// implementation was flawed and caused the localStorage to overflow. This is to
// make sure we clear the storage entry for users who might have a corrupted
// localStorage
localStorage.removeItem("unsync_statements");
